export class FindGroupProjectRoleAction {
  public static readonly type = '[Authorisation] FindGroupProjectRoleAction';
  constructor(
    public readonly userId: string,
    public readonly groupId: string,
  ) {}
}
